import styled from 'styled-components';
import BoxContainer from 'containers/BoxContainer';
import {transparentize} from 'polished';

export const Wrapper = styled(BoxContainer)`
  box-sizing: border-box;
  padding: 14px 20px;
  margin: 10px 0;
  justify-content: space-between;
  align-items: center;
  display: flex;
`;

export const Totals = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  
  column-gap: 20px;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
`;

export const Total = styled.li`
  line-height: 18px;
  font-weight: 500;
  font-size: 14px;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
  
  span {
    color: ${({theme}) => theme.variables.color};
  }
`;
